import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

/**
 * @namespace Plugins
 * @exports Plugins/Vuetify
 * @description Vuetify plugin for Vue
 * @date 2020/02/21
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default new Vuetify({
	breakpoint: {
		thresholds: {
			xl: 999999
		}
	},
	icons: {
		iconfont: 'mdi'
	},
	theme: {
		options: { customProperties: true },
		themes: {
			light: {
				primary: '#1eb0e1',
				secondary: '#1b78d8',
				accent: '#FDE74C',
				info: '#670056',
				success: '#0A8754',
				warning: '#F58F29',
				error: '#FE4A49'

				,newUiLightBlue: '#1EAFE1'
				,newUiBrightBlue: '#1969FF'
				,newUiDarkBlue: '#192864'
				,newUiLightPurple: '#694191'
				,newUiPurple: '#502382'
				,newUiDarkPurple: '#3C1982'
				,newUiBlurple: '#2D1E82'
				,newUiBluePurple: '#5055BE'
				,newUiPurpleAlt: '#553796'
				,newUiBrightPurple: '#690073'
				,newUiDarkPurpleAlt: '#370055'
				,newUiBlack: '#232832'
				,newUiWhite: '#FAF8F4'
				,newUiGrey: '#AAB9BE'
				,newUiDarkGrey: '#737882'
				,newUiGreen: '#5FE678'
				,newUiRed: '#F65424'
			}
		}
	}
});
